import * as tslib_1 from "tslib";
import { SharePointQueryableCollection, SharePointQueryableInstance, defaultPath } from "./sharepointqueryable";
/**
 * Describes a collection of Field objects
 *
 */
var Forms = /** @class */ (function (_super) {
    tslib_1.__extends(Forms, _super);
    function Forms() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets a form by id
     *
     * @param id The guid id of the item to retrieve
     */
    Forms.prototype.getById = function (id) {
        var i = new Form(this);
        i.concat("('" + id + "')");
        return i;
    };
    Forms = tslib_1.__decorate([
        defaultPath("forms")
    ], Forms);
    return Forms;
}(SharePointQueryableCollection));
export { Forms };
/**
 * Describes a single of Form instance
 *
 */
var Form = /** @class */ (function (_super) {
    tslib_1.__extends(Form, _super);
    function Form() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Form;
}(SharePointQueryableInstance));
export { Form };
//# sourceMappingURL=forms.js.map